import axios, { InternalAxiosRequestConfig } from 'axios';

// Host'ga qarab API URL'ni dinamik aniqlaymiz:
//  - localhost'da brauzerda → localhost:8000/api (tunnel kerak emas)
//  - aks holda → REACT_APP_API_URL
const resolveApiBase = (): string => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8000/api';
    }
  }
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl) {
    // Production build'da env yo'q bo'lsa silent'da `localhost:8000`'ga fallback —
    // foydalanuvchi brauzerida ishlamaydi. Tezroq sezish uchun loud fail qilamiz.
    const msg = 'REACT_APP_API_URL is not set in this build.';
    if (process.env.NODE_ENV === 'production') throw new Error(msg);
    // eslint-disable-next-line no-console
    console.warn(msg + ' Falling back to http://localhost:8000/api');
    return 'http://localhost:8000/api';
  }
  return envUrl;
};

const API_BASE_URL = resolveApiBase();

export const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    // Server qaysi ilova so'rayotganini bilishi kerak: bitta API ikkala
    // panelga (amanah.uz va admin.amanah.uz) xizmat qiladi.
    'X-Client-App': 'seller',
  },
  withCredentials: true,
  // Timeout'siz so'rov osilib qolsa, ekran abadiy "yuklanmoqda" holatida
  // turaverardi va foydalanuvchi sababini bilmasdi. Chek PDF va Excel
  // yuklash uzoqroq ketishi mumkin — ular o'z timeout'ini beradi.
  timeout: 30000,
});

// Telegram Mini App ichida ekanligimizni tekshirish
const getTelegramInitData = (): string => {
  try {
    return (window as any).Telegram?.WebApp?.initData || '';
  } catch {
    return '';
  }
};

const isInTelegramMiniApp = (): boolean => Boolean(getTelegramInitData());

/**
 * Request interceptor — auth header.
 *
 * Telegram ichida bo'lsak HMAC bilan imzolangan initData yuboriladi va u
 * BARCHA endpointlarga tegishli: server uni autentifikatsiya sifatida qabul
 * qiladi, ya'ni Mini App oddiy API'dan foydalanadi. Aks holda — DRF Token.
 *
 * Ilgari bu yerda `X-Bot-Token` ham yuborilardi. U shared-secret edi va CRA
 * uni bundle ichiga matn holida yozardi — ya'ni har bir brauzerda ochiq. Endi
 * bot tokeni faqat serverda qoladi.
 */
api.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const initData = getTelegramInitData();
    if (initData) {
      config.headers.set('X-Telegram-Init-Data', initData);
      return config;
    }

    const token = localStorage.getItem('token');
    if (token) {
      config.headers.set('Authorization', `Token ${token}`);
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export const SUBSCRIPTION_EXPIRED = 'subscription_expired';

// Response interceptor
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Telegram ichida login sahifasi yo'q: u yerda 401 "hisob bog'lanmagan"
      // degani bo'lishi mumkin va uni ekranning o'zi hal qiladi.
      if (isInTelegramMiniApp()) {
        return Promise.reject(error);
      }
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    // Obuna ish paytida tugashi mumkin — auth store eshitib, foydalanuvchini
    // Obuna bo'limiga yo'naltiradi (store bu faylni import qiladi, teskarisi
    // aylanma import bo'lardi).
    if (error.response?.status === 403 && error.response?.data?.code === SUBSCRIPTION_EXPIRED) {
      window.dispatchEvent(new Event(SUBSCRIPTION_EXPIRED));
    }
    return Promise.reject(error);
  }
);

export default api;
